module.exports = __webpack_public_path__ + "img/coc-sign.453fcff8.png";